import React from "react";
import { TickLargeOutlined } from "@toddle-edu/ds-icons";
import _ from "lodash";
import moment from "moment";
import { MODALITY_TYPE_INFO_MAPPING } from "UIComponents/AIChat/modules/Constants";

export const getModalityNewVersion = (attachments, presetAttachment) => {
  const map = _.keyBy(attachments, "id");

  // find root from presetAttachment
  let current = map[presetAttachment];
  while (_.get(current, "presetAttachment.id", null) !== null) {
    current = map[current?.presetAttachment?.id] || null;
  }
  const rootId = current?.id; // 1

  // find max version under same root
  const maxVersion = _.max(
    _.map(attachments, att => {
      let node = att;
      while (_.get(node, "presetAttachment.id", null) !== null) {
        node = map[node?.presetAttachment?.id] || null;
      }
      return node?.id === rootId ? _.get(att, "metadata.version", 1) : null;
    })
  );

  return (maxVersion || 0) + 1;
};

/**
 * Groups attachments by their label
 * Returns groups of attachments with the same label
 * @param {Object} params - Parameters object containing t, attachments, selectedAttachmentData, hasOpeningMsgAttachment
 * @returns {Array} - Array of grouped attachments by label
 */
export const groupAttachmentsByPresetChain = params => {
  const { t, attachments, selectedAttachmentData } = params;

  const filteredAttachments = _.filter(
    attachments,
    att => att?.type !== "LINK" || _.has(att, "metadata.checkPoints")
  );

  // Group attachments by label
  const groupedByLabel = _.groupBy(filteredAttachments, "label");

  // Convert groups to the expected format
  return _.map(groupedByLabel, attachmentsInGroup => {
    // Sort attachments by version or createdAt
    const sortedAttachments = _.orderBy(
      attachmentsInGroup,
      [
        item => _.get(item, "metadata.version", 0),
        item => moment(item.createdAt).valueOf(),
      ],
      ["asc", "asc"]
    );

    // Use the first attachment as the representative
    const firstAttachment = _.first(sortedAttachments);
    const { label } = MODALITY_TYPE_INFO_MAPPING[firstAttachment?.type] || {};

    const subText =
      _.size(sortedAttachments) > 1
        ? `${_.size(sortedAttachments)} versions • ${t(label)}`
        : t(label);

    const allIds = _.map(sortedAttachments, "id");

    return {
      ...firstAttachment,
      subText,
      children: _.drop(sortedAttachments, 1), // All except first as children
      allIds,
      suffix: _.includes(allIds, selectedAttachmentData?.id) ? (
        <TickLargeOutlined variant={"subtle"} />
      ) : null,
    };
  });
};

export const getHasBlobImage = html => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return [...doc.querySelectorAll("img")].some(img =>
    img.src.startsWith("blob:")
  );
};
